import ChartsEmbedSDK from '@mongodb-js/charts-embed-dom';
import { FC, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { getConfigurations, useJWT } from 'src/app/common/utils';
import { ChartListParam } from 'src/app/modules/AgencyCampaign/network/dashboardCrud';
import {
  DashboardLibraryCoeDev,
  LMdashboardDataCoeDev,
} from 'src/app/modules/AgencyCampaign/types/dashboard-chartID-coedev';
import { DashboardLibraryProd, LMdashboardDataProd } from 'src/app/modules/AgencyCampaign/types/dashboard-chartID-prod';
import { DashboardLibraryUat, LMdashboardDataUat } from 'src/app/modules/AgencyCampaign/types/dashboard-chartID-uat';
import { LMdashboardFilter } from 'src/app/modules/AgencyCampaign/types/dashboard-types';
import { RootState } from 'src/redux/store';
import { getMongoChartToken } from '../../../../../Auth/_redux/authCrud';
import { TokenInfo } from '@pruforce/common-adminweb-sdk';

// const baseUrl = window.envConfig['REACT_APP_MONGODB_CHART_BASE_URL'];
var libarary = DashboardLibraryCoeDev;
var dataMap = LMdashboardDataCoeDev;

type ChartListProps = {
  filter: ChartListParam;
  onRefresh?: boolean;
  refreshdata: () => void;
  setExcelData: (data: any) => void;
  getDataList: (data: any) => void;
};

const CommonFilters: string[] = [];

const DashboardDetailPage: FC<ChartListProps> = ({ filter, onRefresh, refreshdata, setExcelData, getDataList }) => {
  const user = useSelector<RootState, TokenInfo | undefined>((state) => state.auth.user);
  const jwt = useJWT() || {};
  const { region, channel } = jwt;

  const getEnv = useMemo(() => {
    const env = window.envConfig['REACT_APP_ENV'];
    if (env === 'uat') {
      libarary = DashboardLibraryUat;
      dataMap = LMdashboardDataUat;
    } else {
      if (env === 'prod') {
        libarary = DashboardLibraryProd;
        dataMap = LMdashboardDataProd;
      }
    }
  }, []);

  const baseUrl: string = getConfigurations()?.mongoChart?.baseUrl;

  const sdk = new ChartsEmbedSDK({
    baseUrl,
    getUserToken: async function () {
      const response = await getMongoChartToken();
      return response.accessToken;
    },
  });
  var chartID = '';

  for (var i = 0; i < libarary.report.length; i++) {
    var object = libarary.report[i];
    if (object.chartName == filter.chartName) {
      chartID = object.chartID;
      if (object.chartType == filter.chartType) {
        chartID = object.chartID;
        break;
      }
    }
    // chartID = ""
  }

  const chartDiv = useRef<HTMLDivElement>(null);
  const dataChartDiv = useRef<HTMLDivElement>(null);
  const [rendered, setRendered] = useState(false);
  const [chart, reRender] = useState(
    sdk.createChart({
      chartId: chartID,
      height: 800,
      theme: 'light',
      filter: { $and: [{ region: region }, { channel: channel }] },
    }),
  );

  const [dataChart, reRenData] = useState(
    sdk.createChart({
      chartId: dataMap.get(filter.chartName),
      height: 800,
      theme: 'light',
      filter: { $and: [{ region: region }, { channel: channel }] },
    }),
  );

  const [myFilter, setMyFilter] = useState<any>({
    campaignId: '',
    consultantCode: '',
    campaignStatus: '',
    campaignType: '',
    campaignRecordType: '',
    leadSubSource: '',
    startDate: [],
    campaignStartDt: [],
    assignDate: [],
    region: region,
    channel: channel,
  });

  useEffect(() => {
    if (chartDiv.current && dataChartDiv.current) {
      chart
        .render(chartDiv.current)
        .then(() => {
          setRendered(true);
          chart.getData().then((result) => setExcelData(result));
          chart.getData().then((res) => console.log('documents' + JSON.parse(JSON.stringify(res)).documents.length));
        })
        .catch((err) => console.log('Error during Charts rendering.', err));
      dataChart
        .render(dataChartDiv.current)
        .then(() => {
          dataChart.getData().then((result) => {
            type resultType = keyof typeof result;
            type fieldsType = keyof typeof fields;
            type dataType = keyof (typeof data)[0];
            const fields = result['fields' as resultType] as object;
            const data = result['documents' as resultType] as Array<{ group: string }>;

            let nameObj = {
              campaignId: '',
              campaignStatus: '',
              consultantCode: '',
              campaignType: '',
              campaignRecordType: '',
              leadSubSource: '',
              region: '',
              channel: '',
            };

            type nameType = keyof typeof nameObj;

            // fields[fieldName as fieldsType] -> chart's field name
            for (const fieldName in fields) {
              nameObj[fields[fieldName as fieldsType] as nameType] = fieldName;
            }

            let dataList: Record<string, any[]> = {
              campaignId: [],
              campaignStatus: [],
              consultantCode: [],
              campaignType: [],
              campaignRecordType: [],
              leadSubSource: [],
              region: [],
              channel: [],
            };

            // filter duplicate choices
            data.forEach((item) => {
              for (const key in dataList) {
                if (
                  !!item[nameObj[key as nameType] as dataType] &&
                  !dataList[key].includes(item[nameObj[key as nameType] as dataType])
                ) {
                  dataList[key].push(item[nameObj[key as nameType] as dataType]);
                }
              }
            });
            getDataList(dataList);
          });
        })
        .catch((err) => console.log('Error during Charts rendering.', err));
    } else {
      console.log('Error');
    }
  }, [chartDiv, dataChartDiv, chart, dataChart, rendered, reRenData]);

  useEffect(() => {
    let tmpFilter = myFilter;
    for (const name in filter) {
      type filterKey = keyof typeof filter;
      if (Object.keys(tmpFilter).includes(name)) {
        tmpFilter[name] =
          !!filter[name as filterKey] && filter[name as filterKey] != 'all' ? filter[name as filterKey] : undefined;
      }
    }
    setMyFilter({
      campaignId: !!filter['campaignId'] && filter['campaignId'] != 'all' ? filter['campaignId'] : undefined,
      consultantCode:
        !!filter['consultantCode'] && filter['consultantCode'] != 'all' ? filter['consultantCode'] : undefined,
      campaignStatus:
        !!filter['campaignStatus'] && filter['campaignStatus'] != 'all' ? filter['campaignStatus'] : undefined,
      campaignType: !!filter['campaignType'] && filter['campaignType'] != 'all' ? filter['campaignType'] : undefined,
      campaignRecordType:
        !!filter['campaignRecordType'] && filter['campaignRecordType'] != 'all'
          ? filter['campaignRecordType']
          : undefined,
      leadSubSource:
        !!filter['leadSubSource'] && filter['leadSubSource'] != 'all' ? filter['leadSubSource'] : undefined,
      startDate: !!filter['startDate'] ? filter['startDate'] : undefined,
      campaignStartDt: !!filter['campaignStartDt'] ? filter['campaignStartDt'] : undefined,
      assignDate: !!filter['assignDate'] ? filter['assignDate'] : undefined,
      region: !!filter['region'] ? filter['region'] : region,
      channel: !!filter['channel'] ? filter['channel'] : channel,
    });
  }, [chart, filter, rendered]);

  useEffect(() => {
    let obj = JSON.parse(JSON.stringify(myFilter));
    let chartFilter = LMdashboardFilter.get(filter.chartName);
    // delete the no filterName
    for (const key in obj) {
      if (!chartFilter[key] && !CommonFilters.includes(key)) {
        delete obj[key];
      }
    }
    // pls put the date type to be filtered here
    if (obj?.startDate) {
      if (!!myFilter?.startDate[0] && !!myFilter?.startDate[1]) {
        obj.$and = [
          { startDate: { $gte: new Date(myFilter.startDate[0]) } },
          { startDate: { $lte: new Date(myFilter.startDate[1]) } },
        ];
      }
      delete obj.startDate;
    }
    if (obj?.campaignStartDt) {
      if (!!myFilter?.campaignStartDt[0] && !!myFilter?.campaignStartDt[1]) {
        obj.$and = [
          { campaignStartDt: { $gte: new Date(myFilter.campaignStartDt[0]) } },
          { campaignStartDt: { $lte: new Date(myFilter.campaignStartDt[1]) } },
        ];
      }
      delete obj.campaignStartDt;
    }
    if (obj?.assignDate) {
      if (!!myFilter?.assignDate[0] && !!myFilter?.assignDate[1]) {
        obj.$and = [
          { assignDate: { $gte: new Date(myFilter.assignDate[0]) } },
          { assignDate: { $lte: new Date(myFilter.assignDate[1]) } },
        ];
      }
      delete obj.assignDate;
    }

    //console.log(obj);

    chart.setFilter(obj).catch((err) => console.log('Error while filtering.', err));
  }, [chart, filter, rendered, myFilter]);

  useEffect(() => {
    reRender(
      sdk.createChart({
        chartId: chartID,
        height: 800,
        theme: 'light',
        filter: { $and: [{ region: region }, { channel: channel }] },
      }),
    );
    reRenData(
      sdk.createChart({
        chartId: dataMap.get(filter.chartName),
        height: 800,
        theme: 'light',
        filter: { $and: [{ region: region }, { channel: channel }] },
      }),
    );
  }, [filter.chartName, filter.chartType]);

  useEffect(() => {
    if (chartDiv.current) {
      chart
        .render(chartDiv.current)
        .then(() => {
          setRendered(true);
          setExcelData(chart.getData());
          chart.getData().then((res) => console.log('documents' + JSON.parse(JSON.stringify(res)).documents.length));
        })
        .catch((err) => console.log('Error during get data.', err));
    } else {
      console.log('Error');
    }
  }, [filter.chartName, filter.chartType, rendered]);

  return (
    <>
      <div className="chart" ref={chartDiv} />
      <div className="data-chart" ref={dataChartDiv} hidden />
    </>
  );
};

export default DashboardDetailPage;
